"use client";
import { Stack } from "@chakra-ui/react";
import { TechStackCard } from "../../automation/components/techStack";
import { SectionDivider } from "@/app/components/shared/SectionDivider";
import { LAB_AS_SERVICE_TECH_STACK } from "./constant";

const TechStack = () => {
  return (
    <Stack spacing={6} paddingX={8}>
      <SectionDivider label="Our Tech Stack" bg="transparent" padding={"2.25rem 0"} />
      <Stack spacing={6} data-cy="section-tech-stack" backgroundColor={"#F1F8FF"} p={10}>
        {LAB_AS_SERVICE_TECH_STACK.map((stack, index) => (
          <TechStackCard {...stack} key={index} />
        ))}
      </Stack>
    </Stack>
  );
};

export default TechStack;
